import styled from 'styled-components';
import { NavLink } from 'react-router-dom';

export const BottomNavContainer = styled.nav`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: calc(60px + env(safe-area-inset-bottom, 0px));
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: saturate(180%) blur(12px);
  -webkit-backdrop-filter: saturate(180%) blur(12px);
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 -2px 12px rgba(31, 45, 61, 0.08);
  z-index: 1000;
  padding-bottom: env(safe-area-inset-bottom, 0px);

  @media screen and (min-width: 900px) {
    display: none;
  }
`;

export const BottomNavItem = styled(NavLink)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #8a99a8;
  text-decoration: none;
  font-size: 0.75rem;
  font-weight: 600;
  width: 100%;
  min-height: 48px;
  height: 64px;
  position: relative;
  transition: color 0.2s ease;

  /* active pill — animated green bar that slides down from top */
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%) scaleX(0);
    width: 32px;
    height: 3px;
    border-radius: 0 0 4px 4px;
    background: #01bf71;
    transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1);
  }

  &.active {
    color: #01bf71;
  }

  /* show + spring-pop the pill on active tab */
  &.active::before {
    transform: translateX(-50%) scaleX(1);
  }

  /* icon: scale up when active */
  svg {
    font-size: 1.4rem;
    margin-bottom: 4px;
    transition: transform 0.2s cubic-bezier(0.34, 1.56, 0.64, 1),
                color 0.2s ease;
  }

  &.active svg {
    transform: scale(1.18) translateY(-1px);
  }

  /* tactile press feedback */
  &:active {
    transform: scale(0.90);
  }
`;


export const CartBadge = styled.span`
  position: absolute;
  top: 8px;
  right: calc(50% - 20px);
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  border-radius: 999px;
  background: #ff9a3c;
  color: #fff;
  font-size: 0.65rem;
  font-weight: 800;
  display: grid;
  place-items: center;
  border: 1px solid #fff;
`;
